import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { ORANGE } from "../constants";

export default function TeamHeaderRow({ label }) {
  return (
    <Box
      sx={{
        gridColumn: `1 / -1`,
        height: 36,
        display: "flex",
        alignItems: "center",
        px: 1.5,
        backgroundColor: `${ORANGE}18`,
        borderBottom: `1px solid ${ORANGE}40`,
        position: "sticky",
        left: 0,
        zIndex: 6,
      }}
    >
      <Typography
        variant="caption"
        sx={{
          fontSize: "0.7rem",
          fontWeight: 700,
          color: ORANGE,
          textTransform: "uppercase",
          letterSpacing: "0.3px",
          whiteSpace: "nowrap",
        }}
      >
        {label}
      </Typography>
    </Box>
  );
}
